/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2026-07-03 14:25:00
 * @FilePath: \crane-safety-manager\src\pages\Dashboard\Top5VehiclesByDailyAlarmsCount.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Empty, Modal, Button, Popconfirm } from 'antd';
import moment from 'moment';
import _ from 'lodash';

import usecustomStyles from '../../Common/customStyles';
import * as SThunk from '../../slices/statistics/thunk';

const customStyles = usecustomStyles();

const Top5VehiclesByDailyAlarmsCount = ({ style, getIdByAlarmsCount, vehicleListData }) => {
    const alarmsCount = useSelector(state => state.Statistics.alarmsCount);
    const user = useSelector(state => state.Login.user);
    const [topVehicles, setTopVehicles] = useState([]);
    const [visible, setVisible] = useState(false);
    const [selectedData, setSelectedData] = useState({});

    const payload = {
        'role': user.user?.role || '',
        "startDate": moment().startOf('day').format('YYYY-MM-DD'),
        "endDate": moment().format('YYYY-MM-DD'),
    }

    const dispatch = useDispatch();
    useEffect(() => {
        // 只有当 alarmsCount 为空时才调用 API，避免页面刷新重复查询
        if (!Object.keys(alarmsCount).length) {
            dispatch(SThunk.alarmsCount(payload));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let countList = alarmsCount.length > 0 ? [...alarmsCount].sort((a, b) => b.LCount - a.LCount) : [];
        
        const topList = countList.map((item,i) => (
            <li key={item.name} className='card-list-li' onDoubleClick={()=> getIdByAlarmsCount(item.id,item.name)}>
                <div style={{ display: 'flex', justifyContent:'space-between' }}>
                    <span>
                        <span style={{ margin: '0.5em' }}>{i + 1}.</span>
                        <span>{item.name}</span>
                    </span>{' '}
                    <span>
                        <b style={{ marginRight: '0.5em' }}>{item.LCount} 次</b>
                        <Button
                            onClick={() => handleOperation(item)}
                            style={{ fontSize: '12px', padding: '5.5px 7px', height: '29px',marginRight: '0.5em' }} // 设置按钮样式
                        >操作</Button>
                    </span>                  
                    
                </div>
            </li>
        ));

        setTopVehicles(topList);
    }, [alarmsCount, getIdByAlarmsCount, vehicleListData]);

    const handleOperation = (x) => {
        const role = user?.user?.role;
        if (role === 'ProjectSupervisor') {
            const vehicleMap = vehicleListData.reduce((acc, vehicle) => {
                acc[vehicle.id] = vehicle;
                return acc;
            }, {});
            const updatedList = {
                ...x,
                workers: vehicleMap[x.id]?.workers || []
            };
            setSelectedData(updatedList);
        }else{
            setSelectedData(x);
        }
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };

    const handleResolve = (x) => {
        // 等待 reset 完成后再执行 onlineTime
        dispatch(SThunk.resetAlarm(x.id)).then(() => {
            dispatch(SThunk.alarmsCount(payload));
        });
    };

    const EmptyItem = <Empty image="/nodata.png" description={<span></span>} style={{ padding: '10%' }} />;
    return (
        <Card title="(今日)车辆报警次数 - TOP 5" style={style} bodyStyle={{ height: '91%' }}>
            {topVehicles && topVehicles.length > 0 ? <ul style={{ listStyleType: 'none', padding: 0, height: "15em", overflowY: 'auto' }}>{topVehicles}</ul> : EmptyItem}
            <Modal
                title={selectedData?.name}
                visible={visible}
                onOk={handleOk}
                onCancel={handleCancel}
                // okText="确认"
                // cancelText="取消"
                width={400}
                footer={null} // 移除底部按钮
            >
                <div>联系人及电话:  {!selectedData?.workers &&<span>{selectedData?.owner_name}-{selectedData?.owner_phone}</span>}</div>
                {selectedData?.workers?.map((worker, index) => (
                    <li key={index}>{worker.name} {worker.role} {worker.phone || '暂无联系电话'}</li>
                ))}
                <Popconfirm
                    title="确认设置已处理，重置该项目下的所有车辆报警次数吗？"
                    onConfirm={() => handleResolve(selectedData)}
                    okText="确认"
                    cancelText="取消"
                >
                    <Button
                        type="primary"
                        style={{ fontSize: '12px', padding: '5.5px 7px',margin: '0.5em 0', height: '29px' }} // 设置按钮样式
                    >已处理</Button>
                </Popconfirm>
            </Modal>
        </Card>
    );
};

export default Top5VehiclesByDailyAlarmsCount;
